<template>
  <div v-if="component" class="ShopItem">
    <component :is="component" v-bind="props" />
  </div>
</template>

<script>
import MasterclassShop from '../masterclass/MasterclassShop'

export default {
  name: 'ShopItem',
  computed: {
    type() {
      return this.$route.params.type
    },
    contentId() {
      return this.$route.params.productId
    },
    component() {
      switch (this.type) {
        case 'masterclass':
          return MasterclassShop

        default:
          return null
      }
    },
    props() {
      switch (this.type) {
        case 'masterclass':
          return { masterclassId: this.contentId }

        default:
          return null
      }
    }
  }
}
</script>
